import { SllProgram } from "@src/api/graphql-codegen";

export const planOptions = [
  'I will be running lessons with students',
  'I am reviewing the program',
  'I oversee others who run lessons with students',
  'I plan to access the Educator Well-being resources',
  'Unsure',
].map(v => ({ label: v, value: v }));

export const AusStudentVoiceSeries: SllProgram = {
  __typename: 'SLLProgram',
  avgDuration: '12-45',
  country: "Australia",
  description: "Student Voice Series is a compilation of lessons that follow a single student’s story of struggle and success. Through peer voices, these lessons help make the content relatable, reminding students that we all struggle and that there are strategies they can learn to help themselves and others overcome a variety of challenges.",
  grade: 'Kindy - 12',
  iconUrl: 'https://cdn.lordicon.com/pmfpsjek.json',
  id: "studentvoiceseries",
  isShown: true,
  name: "Student Voice Series",
  numberOfLessons: '280+',
  position: 0,
  tier: "Tier 1,2,3",
  labels: 'None',
};